import { Text, Tooltip } from "@mantine/core"
import { SimpleWorkArea } from "../../../../../../@client/Theasoft_ApiServer_WorkAreas"
import { DepartmentContractDto } from "../../../../../../@client/Theasoft_ApiServer_Orchestra"
import css from "./cells.module.css"
import { match } from "ts-pattern"
import { MatrixOrientation } from "../matrix-css-grid"
import { Permission } from "../../../../../../@client/Theasoft_DataTypes_Enums"
import { SuspenseWithFallback } from "../../../../../../-components/suspense"
import { PersonName } from "@components/PersonName"
import { SimpleDutyRosterPeriod } from "@/@client/Theasoft_ApiServer_DutyRosterPeriods"
// y dimesion (normal mode) are contracts or work areas
export type WorkareaOrContract =
  | DataY_WorkArea
  | DataY_WorkareaStatus
  | DataY_Contract

export type DataY_WorkArea = {
  type: "workarea"
  permission: Permission
  data: SimpleWorkArea
  workareaId: number
}

export type DataY_WorkareaStatus = {
  type: "workarea-status"
  permission: Permission
  data: SimpleDutyRosterPeriod[]
  workareaId: number
}

export type DataY_Contract = {
  type: "contract"
  permission: Permission
  data: DepartmentContractDto
  workareaId: number
}

function PersonTooltip({ id }: { id: number }) {
  return (
    <SuspenseWithFallback>
      <PersonName personId={id} />
    </SuspenseWithFallback>
  )
}

export function WorkareaOrContractHeaderCell({
  y,
  orientation,
}: {
  y: WorkareaOrContract
  orientation: MatrixOrientation
}) {
  const className = match(y.type)
    .with("contract", () => "contract-header-cell")
    .with("workarea", () => "workarea-header-cell")
    .with("workarea-status", () => "workarea-header-cell")
    .exhaustive()
  return (
    <div
      className={css[className]}
      style={{
        left: orientation == "normal" ? 0 : undefined,
        top: orientation == "transpose" ? 0 : undefined,
        borderBottom: orientation == "normal" ? "none" : undefined,
        borderRight: orientation == "transpose" ? "none" : undefined,
        background:
          y.type === "contract" && y.data.sort >= 1000
            ? `repeating-linear-gradient(
  45deg,
  var(--mantine-color-body),
  var(--mantine-color-body) 3px,
  var(--mantine-color-dark-light) 3px,
  var(--mantine-color-dark-light) 6px
)`
            : undefined,
      }}
    >
      {y.type == "contract" ? (
        <Tooltip
          label={
            <div>
              <PersonTooltip id={y.data.person.personId} />
            </div>
          }
        >
          <Text size={"xs"} fw={500} c="bright" truncate>
            {y.data.contractType.infoCode} {y.data.person.nameAbbreviated}
          </Text>
        </Tooltip>
      ) : (
        <Tooltip
          disabled={y.type === "workarea-status"}
          label={y.type === "workarea-status" ? "" : y.data.name}
        >
          <Text
            size={"xs"}
            fw={700}
            tt="uppercase"
            fs="italic"
            c="bright"
            truncate
          >
            {y.type === "workarea-status" ? "Status" : y.data.name}
          </Text>
        </Tooltip>
      )}
    </div>
  )
}
